import './Finalize.css'

function Finalize(props) {
  const { success, showFinalize } = props
  
  return (
    showFinalize &&
    <div className='finalize'>
      {success &&
        <div className='success' data-testid='success' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          <div className='success-spacer' />
          <div className='success-message flex-container'>
            <div className='success-spacer' />
            <div className='flex-child first-child success-image'>
              <svg id='Layer_1' height='64' style={{ 'enable-background': 'new 0 0 512 512' }} version='1.1' viewBox='0 0 512 512'>
                <path style={{ fill: '#2BB673' }} d='M489,255.9c0-0.2,0-0.5,0-0.7c0-1.6,0-3.2-0.1-4.7c0-0.9-0.1-1.8-0.1-2.8c0-0.9-0.1-1.8-0.1-2.7  c-0.1-1.1-0.1-2.2-0.2-3.3c0-0.7-0.1-1.4-0.1-2.1c-0.1-1.2-0.2-2.4-0.3-3.6c0-0.5-0.1-1.1-0.1-1.6c-0.1-1.3-0.3-2.6-0.4-4  c0-0.3-0.1-0.7-0.1-1C474.3,113.2,375.7,22.9,256,22.9S37.7,113.2,24.5,229.5c0,0.3-0.1,0.7-0.1,1c-0.1,1.3-0.3,2.6-0.4,4  c-0.1,0.5-0.1,1.1-0.1,1.6c-0.1,1.2-0.2,2.4-0.3,3.6c0,0.7-0.1,1.4-0.1,2.1c-0.1,1.1-0.1,2.2-0.2,3.3c0,0.9-0.1,1.8-0.1,2.7  c0,0.9-0.1,1.8-0.1,2.8c0,1.6-0.1,3.2-0.1,4.7c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0.1s0,0,0,0.1c0,0.2,0,0.5,0,0.7c0,1.6,0,3.2,0.1,4.7  c0,0.9,0.1,1.8,0.1,2.8c0,0.9,0.1,1.8,0.1,2.7c0.1,1.1,0.1,2.2,0.2,3.3c0,0.7,0.1,1.4,0.1,2.1c0.1,1.2,0.2,2.4,0.3,3.6  c0,0.5,0.1,1.1,0.1,1.6c0.1,1.3,0.3,2.6,0.4,4c0,0.3,0.1,0.7,0.1,1C37.7,398.8,136.3,489.1,256,489.1s218.3-90.3,231.5-206.5  c0-0.3,0.1-0.7,0.1-1c0.1-1.3,0.3-2.6,0.4-4c0.1-0.5,0.1-1.1,0.1-1.6c0.1-1.2,0.2-2.4,0.3-3.6c0-0.7,0.1-1.4,0.1-2.1  c0.1-1.1,0.1-2.2,0.2-3.3c0-0.9,0.1-1.8,0.1-2.7c0-0.9,0.1-1.8,0.1-2.8c0-1.6,0.1-3.2,0.1-4.7c0-0.2,0-0.5,0-0.7  C489,256,489,256,489,255.9C489,256,489,256,489,255.9z' id='XMLID_3_' /><g id='XMLID_1_'><line style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth: 30, 'stroke-miterlimit': 10 }} id='XMLID_2_' x1='213.6' x2='369.7' y1='344.2' y2='188.2' /><line style={{ fill: 'none', stroke: '#FFFFFF', strokeWidth: 30, 'stroke-miterlimit': 10 }} id='XMLID_4_' x1='233.8' x2='154.7' y1='345.2' y2='266.1' /></g>
              </svg>
            </div>
            <div className='flex-child failure-message'>
              Thank you for your payment
              <br />
              {props.user + ' (' + props.createdBy + ')'}
              <br />
              {props.currentTime}
            </div>
            <div className='success-spacer' />
          </div>
        </div>}
      {!success &&
        <div className='failure' data-testid='failure'>
          <div className='failure-spacer' />
          <div className='failure-message flex-container'>
            <div className='failure-spacer' />
            <div className='flex-child first-child failure-image'>
              <svg className='icon' height='64' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg'><path d='M490.666667 490.666667m-320 0a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z' fill='#FA3239' /><path d='M520.533333 490.666667L640 371.2l-29.866667-29.866667-119.466666 119.466667L375.466667 341.333333l-34.133334 34.133334 119.466667 119.466666L341.333333 610.133333l29.866667 29.866667 119.466667-119.466667 119.466666 119.466667 34.133334-34.133333-123.733334-115.2z' fill='#FFFFFF' /></svg>
            </div>
            <div className='flex-child failure-message'>
              Your payment was declined
              <br />
              {props.user + ' (' + props.createdBy + ')'}
              <br />
              {props.currentTime}
            </div>
            <div className='failure-spacer' />
          </div>
        </div>}
    </div>
  )
}

export default Finalize
